module.exports = __webpack_public_path__ + "01_short_gray.5b15fe23.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_short_gray.png
// module id = tLgs
// module chunks = 0